import './DiscussionShowHeader.scss';

import PropTypes from 'prop-types';
import React, { Fragment, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { discussionCategoryMap } from 'shared/utils/formOptions';
import { format } from 'shared/utils/utils';

import Avatar from 'components/ui/Avatar';
import SubjectsList from 'components/ui/SubjectsList';

const DiscussionShowHeader = ({
  categoryId,
  dateCreated,
  title,
  subjects,
  curriculums,
  likeCount,
  views,
  commentCount,
  isLiked,
  author,
  isBest,
}) => {
  const { t } = useTranslation('discussion');

  const AuthorTag =
    author.type === 'tutor' || author.type === 'student' ? Link : Fragment;

  const getNickname = () => {
    switch (author?.type) {
      case 'deleted':
        return '알 수 없음';
      case 'anonymous':
        return '익명';
      default:
        return author?.nickname;
    }
  };

  return (
    <div className="discussion-show-header">
      <ul className="counts">
        <li>조회 {views?.toLocaleString()}</li>
        <li>
          {isLiked ? <>&hearts; </> : <>&#9825; </>}
          {likeCount?.toLocaleString()}
        </li>
      </ul>
      <div className="ds-content-wrap">
        <div className="ds-content">
          <span className="ds-title">
            {!!isBest && <span className="best">Best</span>}
            {discussionCategoryMap(t)[categoryId]
              ? `[${discussionCategoryMap(t)[categoryId]}] `
              : ''}
            {title}
          </span>
          <ul className="ds-details">
            <li className="author">
              <AuthorTag
                {...(author.type === 'tutor' || author.type === 'student'
                  ? { to: `/${author.type}s/${author.id}` }
                  : {})}
              >
                {!!author.picture && author.type === 'tutor' && (
                  <Avatar size={16} src={author.picture} />
                )}
                <span>{getNickname()}</span>
              </AuthorTag>
            </li>
            <li>{format(dateCreated, 'yyyy. MM. dd.')}</li>
          </ul>
        </div>
        <span className="comment-count">{commentCount}</span>
      </div>
      {(!!subjects.length || !!curriculums.length) && (
        <div className="topic-container">
          <SubjectsList subjects={subjects} curriculums={curriculums} />
        </div>
      )}
    </div>
  );
};

DiscussionShowHeader.propTypes = {
  categoryId: PropTypes.number.isRequired,
  dateCreated: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subjects: PropTypes.array,
  curriculums: PropTypes.array,
  likeCount: PropTypes.number.isRequired,
  views: PropTypes.number.isRequired,
  commentCount: PropTypes.number.isRequired,
  isLiked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  author: PropTypes.object.isRequired,
  isBest: PropTypes.number.isRequired,
};

DiscussionShowHeader.defaultProps = {
  subjects: [],
  curriculums: [],
};

export default memo(DiscussionShowHeader);
